import React from "react";
import { motion } from "framer-motion";

const CountryLabel = ({ label }) => {
  return (
    <motion.div
      initial={{ scaleY: 0 }}
      animate={{ scaleY: 1 }}
      className={`absolute top-2 z-50 mt-2 flex w-full origin-top transform items-center justify-center transition-transform duration-500 `}
    >
      <div className="text-md animate-slide-out items-center justify-center overflow-hidden overflow-ellipsis rounded border-2 border-majky-400 bg-majky-300 bg-opacity-80 px-1 py-1 text-center text-majky-900">
        <span className="font-semibold">{label}</span>
      </div>
    </motion.div>
  );
};
export default CountryLabel;
